export enum FONTS {
  SFProText = 'SFProText-Regular',
  SFProTextSemiBold = 'SFProText-Semibold'
}